/* src/components/ui/UpdateAvailableModal.js */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons'; // Using a sync/refresh icon

const UpdateAvailableModal = ({ isOpen, onUpdate }) => {
  if (!isOpen) return null;

  // No close button needed - activating update refreshes the page.
  // If needed, a "Later" button could be added that just hides the modal
  // without calling activateUpdate, but typically updates are forced on reload.

  const handleUpdate = () => {
      onUpdate(); // Trigger the update logic from parent (context)
  };

  return (
    <div className="fixed z-[100] inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-center sm:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay - Not clickable to close */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

        {/* Mobile bottom sheet style (or centered modal on larger screens) */}
        <div className="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
           <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full w-full">
             {/* No explicit close button needed as update forces reload */}

             <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                 <div className="text-center">
                     <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
                          <FontAwesomeIcon icon={faSync} className="h-6 w-6 text-blue-600 animate-spin" aria-hidden="true" />
                      </div>
                     <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2" id="modal-title">
                         Update Available
                     </h3>
                     <div className="mt-2 text-sm text-gray-600 space-y-3">
                         <p>
                             A new version of the application is ready. Update now to get the latest features and improvements.
                         </p>
                         <p className="text-xs text-gray-500">
                             The app will reload after updating.
                         </p>
                     </div>
                 </div>
             </div>
             <div className="bg-gray-50 px-4 py-3 sm:px-6 flex justify-center">
                  <button
                     type="button"
                     className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm"
                     onClick={handleUpdate}
                 >
                     Update Now
                 </button>
                 {/* Optional "Later" button - typically not needed as SW update often happens on next load anyway */}
                 {/* <button
                     type="button"
                     className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                     onClick={onClose} // Assuming an onClose prop if needed
                 >
                     Later
                 </button> */}
             </div>
           </div>
        </div>
      </div>
    </div>
  );
};

UpdateAvailableModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired, // Function to call when user clicks update
  // onClose: PropTypes.func, // Add if implementing a "Later" button
};

export default UpdateAvailableModal;